module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "name": "hres78u-popup-approve",
      "id": "hres78u-popup-approve",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header header-popup"
  }, [_c('button', {
    ref: "popupApproveModalButton",
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['0']))])]), _vm._v(" "), (!_vm.showTrailRepayment && !_vm.showPersonaldata) ? _c('div', {
    staticClass: "modal-body detail detail-responsive"
  }, [_c('div', {
    staticClass: "detail detail-responsive"
  }, [_c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "coddesc_codempid",
      "name": "desc_codempid"
    }
  }, [_vm._v(_vm._s(_vm.approve.desc_codempid))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['40']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "coddesc_codappr",
      "name": "codappr"
    }
  }, [_vm._v(_vm._s(_vm.approve.codappr) + " - " + _vm._s(_vm.approve.desc_codappr))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['50']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [(_vm.approve.flgStaappr === 'A') ? [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "currentDate",
      "has-error": _vm.errors.has('currentDate')
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  }), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|after:currentDate'),
      expression: "'required|date_format:DD/MM/YYYY|after:currentDate'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dteappr",
      "has-error": _vm.errors.has('dteappr')
    },
    model: {
      value: (_vm.approve.dteappr),
      callback: function($$v) {
        _vm.$set(_vm.approve, "dteappr", $$v)
      },
      expression: "approve.dteappr"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteappr')),
      expression: "errors.has('dteappr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteappr')))])] : [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "currentDate"
    },
    model: {
      value: (_vm.currentDate),
      callback: function($$v) {
        _vm.currentDate = $$v
      },
      expression: "currentDate"
    }
  })], 1)]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['60']))]), _vm._v(" "), (_vm.approve.flgStaappr === 'A') ? [_c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.numcont),
      expression: "approve.numcont"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15'),
      expression: "'required|max:15'"
    }],
    staticClass: "detail-text  width-70 input-text",
    class: {
      'input-error': _vm.errors.has('numcont')
    },
    attrs: {
      "type": "text",
      "id": "numcont",
      "name": "numcont",
      "maxlength": "15",
      "data-vv-name": "numcont"
    },
    domProps: {
      "value": (_vm.approve.numcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "numcont", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-error",
    attrs: {
      "id": "form-errors-p_dteyear"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numcont')),
      expression: "errors.has('numcont')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numcont')))])])] : [_c('div', {
    staticClass: "detail-right"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.numcont),
      expression: "approve.numcont"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:15'),
      expression: "'required|max:15'"
    }],
    staticClass: "detail-text  width-70 input-text",
    attrs: {
      "type": "text",
      "id": "numcont",
      "name": "numcont",
      "maxlength": "15"
    },
    domProps: {
      "value": (_vm.approve.numcont)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "numcont", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-error",
    attrs: {
      "id": "form-errors-p_dteyear"
    }
  })])]], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['70']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [(_vm.approve.flgStaappr === 'A') ? [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dtelonst",
      "has-error": _vm.errors.has('dtelonst')
    },
    model: {
      value: (_vm.approve.dtelonst),
      callback: function($$v) {
        _vm.$set(_vm.approve, "dtelonst", $$v)
      },
      expression: "approve.dtelonst"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtelonst')),
      expression: "errors.has('dtelonst')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtelonst')))])] : [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY'),
      expression: "'required|date_format:DD/MM/YYYY'"
    }],
    attrs: {
      "data-vv-value-path": "inputDate",
      "name": "dtelonst"
    },
    model: {
      value: (_vm.approve.dtelonst),
      callback: function($$v) {
        _vm.$set(_vm.approve, "dtelonst", $$v)
      },
      expression: "approve.dtelonst"
    }
  })], 1)]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-num-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "width-75",
    attrs: {
      "numLength": 9,
      "decimal": 2,
      "name": "amtlon",
      "data-vv-name": "amtlon",
      "has-error": _vm.errors.has('amtlon')
    },
    model: {
      value: (_vm.approve.amtlon),
      callback: function($$v) {
        _vm.$set(_vm.approve, "amtlon", $$v)
      },
      expression: "approve.amtlon"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC5']['60']))])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['90']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-num-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenNotExist:numlonreqmth2'),
      expression: "'requiredWhenNotExist:numlonreqmth2'"
    }],
    class: {
      'input-error': _vm.errors.has('numlonreqyr2')
    },
    attrs: {
      "id": "numlonreqyr2",
      "name": "numlonreqyr2",
      "numLength": 2,
      "decimal": 0,
      "data-vv-name": "numlonreqyr2"
    },
    model: {
      value: (_vm.approve.numlonreqyr),
      callback: function($$v) {
        _vm.$set(_vm.approve, "numlonreqyr", $$v)
      },
      expression: "approve.numlonreqyr"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['100']))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numlonreqyr2')),
      expression: "errors.has('numlonreqyr2')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numlonreqyr2')))]), _vm._v(" "), _c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-num-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenNotExist:numlonreqmth2'),
      expression: "'requiredWhenNotExist:numlonreqmth2'"
    }],
    class: {
      'input-error': _vm.errors.has('numlonreqmth2')
    },
    attrs: {
      "id": "numlonreqmth2",
      "name": "numlonreqmth2",
      "numLength": 2,
      "decimal": 0,
      "data-vv-name": "numlonreqmth2"
    },
    model: {
      value: (_vm.approve.numlonreqmth),
      callback: function($$v) {
        _vm.$set(_vm.approve, "numlonreqmth", $$v)
      },
      expression: "approve.numlonreqmth"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['110']))])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('numlonreqmth2')),
      expression: "errors.has('numlonreqmth2')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('numlonreqmth2')))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['120']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [(_vm.approve.flgStaappr === 'A') ? [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.arrTypintr[_vm.nowLang],
      "data-vv-value-path": "inputValue",
      "data-vv-name": "typintr",
      "has-error": _vm.errors.has('typintr')
    },
    model: {
      value: (_vm.approve.typintr),
      callback: function($$v) {
        _vm.$set(_vm.approve, "typintr", $$v)
      },
      expression: "approve.typintr"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('typintr')),
      expression: "errors.has('typintr')"
    }],
    staticClass: "text-error",
    attrs: {
      "disabled": _vm.eventBtn === 'reject'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('typintr')))])] : [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('hrms-dropdown', {
    attrs: {
      "options": _vm.arrTypintr[_vm.nowLang],
      "data-vv-value-path": "inputValue",
      "data-vv-name": "typintr"
    },
    model: {
      value: (_vm.approve.typintr),
      callback: function($$v) {
        _vm.$set(_vm.approve, "typintr", $$v)
      },
      expression: "approve.typintr"
    }
  })], 1)]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['130']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [(_vm.approve.typintr === '2') ? [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.rateilon),
      expression: "approve.rateilon"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:6'),
      expression: "'required|max:6'"
    }],
    staticClass: "form-control input-text",
    class: {
      'input-error': _vm.errors.has('rateilon')
    },
    attrs: {
      "type": "text",
      "id": "rateilon",
      "name": "rateilon",
      "maxlength": "6",
      "data-vv-name": "rateilon"
    },
    domProps: {
      "value": (_vm.approve.rateilon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "rateilon", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC5']['310']))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('rateilon')),
      expression: "errors.has('rateilon')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('rateilon')))])] : [_c('div', {
    staticClass: "input-group  width-70"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.rateilon),
      expression: "approve.rateilon"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:6'),
      expression: "'required|max:6'"
    }],
    staticClass: "form-control input-text",
    attrs: {
      "type": "text",
      "id": "rateilon",
      "name": "rateilon",
      "maxlength": "6",
      "disabled": _vm.approve.typintr === '2' ? false : true
    },
    domProps: {
      "value": (_vm.approve.rateilon)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "rateilon", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-addon input-group-addon-cust"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC5']['310']))])])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['140']))]), _vm._v(" "), _c('div', {
    staticClass: "detail-right"
  }, [_c('div', {
    staticClass: "detail-text  width-70",
    attrs: {
      "id": "status",
      "name": "status"
    }
  }, [_vm._v(_vm._s(_vm.approve.status))])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix detail-row"
  }, [_c('div', {
    staticClass: "detail-left label-left"
  }, [_vm._v(_vm._s(_vm.labels['HRES78UC2']['180']))]), _vm._v(" "), (_vm.approve.flgStaappr === 'N') ? [_c('div', {
    staticClass: "detail-right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.remark),
      expression: "approve.remark"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:500'),
      expression: "'required|max:500'"
    }],
    staticClass: "textarea-text  width-70",
    class: {
      'input-error': _vm.errors.has('remark')
    },
    attrs: {
      "id": "remark",
      "name": "remark",
      "maxlength": "500",
      "data-vv-name": "remark"
    },
    domProps: {
      "value": (_vm.approve.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remark')),
      expression: "errors.has('remark')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('remark')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(500)))])])] : [_c('div', {
    staticClass: "detail-right"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.approve.remark),
      expression: "approve.remark"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:500'),
      expression: "'max:500'"
    }],
    staticClass: "textarea-text width-70",
    class: {
      'input-error': _vm.errors.has('remark')
    },
    attrs: {
      "id": "remark",
      "name": "remark",
      "maxlength": "500",
      "data-vv-name": "remark"
    },
    domProps: {
      "value": (_vm.approve.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.approve, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remark')),
      expression: "errors.has('remark')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('remark')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(500)))])])]], 2), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    staticStyle: {
      "margin": "15px 0 0 5px"
    },
    attrs: {
      "type": "button",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.toggleTrailRepayment()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bitcoin"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES78UC2']['190']) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn bg-dark-gray",
    staticStyle: {
      "margin": "15px 0 0 5px"
    },
    attrs: {
      "type": "button",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        _vm.togglePersonaldata()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" " + _vm._s(_vm.labels['HRES78UC5']['320']) + "\n              ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showTrailRepayment) ? _c('popup-trial-repayment', {
    attrs: {
      "showTrailRepayment": _vm.showTrailRepayment,
      "trailRepayment": _vm.trailRepayment,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "arrTypintr": _vm.arrTypintr,
      "indexSelected": _vm.indexSelected,
      "setShowTrailRepayment": _vm.setShowTrailRepayment,
      "toggleProcessTable": _vm.toggleProcessTable,
      "showProcessTable": _vm.showProcessTable,
      "columnsProcessTable": _vm.columnsProcessTable,
      "tableProcess": _vm.tableProcess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showPersonaldata) ? _c('popup-personaldata', {
    attrs: {
      "showPersonaldata": _vm.showPersonaldata,
      "dataPersonal": _vm.datapersonal,
      "labels": _vm.labels,
      "labelsButton": _vm.labelsButton,
      "nowLang": _vm.nowLang,
      "approve": _vm.approve,
      "setShowPersonaldata": _vm.setShowPersonaldata
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-footer align-center border-color-skin"
  }, [(!_vm.showTrailRepayment && !_vm.showPersonaldata) ? _c('button', {
    staticClass: "btn bg-green",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.validatePopupApprove()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(" " + _vm._s(_vm.labelsButton['approve']))]) : _vm._e()])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2d60a72a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres78u/popupApprove.vue
// module id = 3655
// module chunks = 1